<template>
  <input
    :id="input_id"
    :style="input_style"
    :currency="'USD'"
    :name="input_name"
    v-model="price"
    v-currency="configs"
  />
</template>

<script>
import { CurrencyDirective } from "vue-currency-input";
export default {
  name: "money",
  directives: { currency: CurrencyDirective },
  props: {
    value: {
      type: [String, Number],
      default: 0
    },
    currency: {
      type: String,
      default: "USD"
    },
    locale: {
      type: String,
      default: "en"
    },
    input_name: {
      type: String,
      default: ""
    },
    input_style: {
      type: String,
      default:
        "border: 1px solid #ccc;border-radius: 3px;padding: 10px 19px;color:#555;"
    },
    input_id: {
      type: String,
      default: "price"
    }
  },
  data() {
    return {
      configs: { currency: this.currency, locale: this.locale },
      price: ""
    };
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.price = this.value;
        //this.$emit("input", parseInt(this.value));
      }
    },
    price: {
      immediate: true,
      handler() {
        if (this.price) {
          this.$emit("input", this.price);
        }
      }
    }
  }
};
</script>
